var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "frame", class: { loggedOut: !_vm.loggedIn } },
    [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "headerBackground" }, [
            _c(
              "svg",
              {
                attrs: {
                  height: "100%",
                  width: "100%",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#5fa9ff",
                    "stroke-width": "5"
                  },
                  attrs: {
                    d:
                      "M 28 64 A 1 1 0 0 0 16 64 A 1 1 0 0 0 28 64 L 96 64 L 141 36 L 245 36 A 1 1 0 0 0 257 36 A 1 1 0 0 0 245 36"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown",
              on: {
                mouseenter: function($event) {
                  _vm.showDropdown = true
                },
                mouseleave: function($event) {
                  _vm.showDropdown = false
                }
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.showDropdown
                ? _c("ul", { staticClass: "dropdown-content" }, [
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/home" } }, [
                          _vm._v("Home")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/home/about" } }, [
                          _vm._v("About Us")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/home/services" } }, [
                          _vm._v("Services")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/home/resources" } },
                          [_vm._v("Resources")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/home/contact" } }, [
                          _vm._v("Contact Us")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/0200" } }, [
                          _vm._v("Login")
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("nav", { staticClass: "tabs" }, [
            _c("ul", [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/home/about" } }, [
                    _vm._v("about us")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/home/services" } }, [
                    _vm._v("services")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/home/resources" } }, [
                    _vm._v("resources")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/home/contact" } }, [
                    _vm._v("contact us")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("router-link", { staticClass: "logo", attrs: { to: "/home" } }, [
            _vm._v("\n            LD Power Automation\n        ")
          ]),
          _vm._v(" "),
          _c("router-link", { staticClass: "login", attrs: { to: "/0200" } }, [
            _vm._v("\n            login\n        ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [_c("router-view")], 1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "burger" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74b1de62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b1de62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 451
// module chunks = 0